export function replaceInArrayByIndex<T>(values: T[], index: number, value: T): T[] {
	const copy = values.concat()
	copy.splice(index, 1, value)
	return copy
}
